import { TicketDistribution } from '@shared/enums/TicketDistribution';
import { IDropdownModelString } from '@shared/models/dropdown-string-model';
import { ActivityTimeRange, IActivityLogBase } from '@shared/services/activity-service/activity.models';

export interface IETickets {
    eTickets: IETicket[];
}

export class ETickets implements IETickets {
    constructor(
        public eTickets: IETicket[]
    ) { }
}

export interface IETicket {
    id: string;
    name: string;
    distributionType: TicketDistribution;
    numberDistributed: number;
    linkedToVenue: boolean;
    linkedToCustomFields: boolean;
}

export class ETicket implements IETicket {
    constructor(
        public id: string,
        public name: string,
        public distributionType: TicketDistribution,
        public numberDistributed: number,
        public linkedToVenue: boolean,
        public linkedToCustomFields: boolean
    ) { }
}

export interface IETicketsForDropdown {
    eTickets: IDropdownModelString[];
}

export class ETicketsForDropdown implements IETicketsForDropdown {
    constructor(
        public eTickets: IDropdownModelString[]
    ) { }
}

export interface IEditETicket {
    id: string;
    name: string;
    distributionType: TicketDistribution;
    linkedToVenue: boolean;
    linkedToCustomFields: boolean;
}

export class EditETicket implements IEditETicket {
    constructor(
        public id: string,
        public name: string,
        public distributionType: TicketDistribution,
        public linkedToVenue: boolean,
        public linkedToCustomFields: boolean
    ) { }
}

export class ActivityFilter {
    constructor(
        public timeRange: ActivityTimeRange,
        public category: ActivityCategory = null,
        public userId: string = null,
        public searchAttendee = null,
        public searchTicket = null,
        public searchVenue = null) { }
  }

export enum ActivityCategory {
    CheckIn = 0,
    CheckOut = 1,
}

export enum AttendeeType {
    Invitee = 0,
    ExtraGuest = 1,
}

export interface IActivityLog  extends IActivityLogBase {
    checkedInDuration: string;
    showExtraGuests: boolean;
    eventName: string;
    inviteeName: string;
    inviteeEmail: string;
    attendeeName: string;
    attendeeEmail: string;
    venueName: string;
    ticketName: string;
    attendeeType: AttendeeType;
}

export interface IActivityLogs {
    activities: IActivityLog[];
}
